import { Directive, ViewContainerRef, inject } from '@angular/core';

@Directive({
  // eslint-disable-next-line @angular-eslint/directive-selector
  selector: '[modalContentHost]'
})
export class ModalContentHostDirective {
  viewContainerRef = inject(ViewContainerRef);
}

@Directive({
  // eslint-disable-next-line @angular-eslint/directive-selector
  selector: '[modalAnchor]'
})
export class ModalAnchorDirective {
  viewContainerRef = inject(ViewContainerRef);
}
